import { Order } from "models/order-management/models";
import { OrderLevelOfCareAllOfPatientLocation } from "models/order-management/orderLevelOfCareAllOfPatientLocation";
import { StatefulOrderResponse } from "models/order-management/statefullOrderResponse";
import CredentialedResource from "models/resource-management/credentialed-resource";

// This is a partial model specifically for Medication Orders
interface OrderDosageParameters {
  dosageParameters: string[];
  dosage: string[];
  frequency: string[];
}

export interface OrderFormState {
  dosageParameters?: OrderDosageParameters;
  approvalType?: Order.ApprovalTypeEnum;
  order?: StatefulOrderResponse;
  locOrders?: Array<StatefulOrderResponse>;
  vfOrders?: Array<StatefulOrderResponse>;
  overlappingVfOrders?: Array<StatefulOrderResponse>;
  // orderId → ISO datetime of the latest COMPLETED visit on that order.
  // Pre-fetched at modal open for every entry in vfOrders. Absent key = no completed visits.
  // Used by the VF backdated-compliance warning (NOVA-1439).
  latestCompletedVisitByOrderId?: Record<string, string>;
  levelOfCare?: string;
  careLocationType?: string;
  patientLocation?: OrderLevelOfCareAllOfPatientLocation;
  careLocation?: string;
  visits?: number;
  timeInterval?: string;
  durationInterval?: string;
  discipline?: string;
  duration?: number;
  startDate?: Date;
  formType?: "entry" | "amendment" | "convertToOrder";
  credentialedResource?: CredentialedResource;
  isCompound?: boolean;
  medRouteId?: number;
  patientChartId?: number;
  nameDescription?: string;
  MAR?: boolean;
  PRN?: boolean;
  PRNQuantity?: number;
  routedMedDescription?: string;
  isSameProvider?: boolean;
  declined?: boolean;
  otherDiscipline?: string;
  hospicePays?: boolean;
  isEPrescribeEnabled?: boolean;
  benefitPeriodCertificationEndDate?: Date;
}

export namespace OrderFormState {
  export function shouldClear(
    componentField: string,
    oldState: OrderFormState = {},
    newState: OrderFormState = {}
  ) {
    if (oldState.declined === true && newState.declined === false) {
      return [
        // date-picker
        "declinedDate",
        // text-area
        "declinedReason",
        "discontinueDate",
      ].includes(componentField);
    } else if (!oldState.declined && newState.declined === true) {
      return [
        // date-picker
        "declinedDate",
        // text-area
        "providerNotes",
        // checkbox
        "eSignVerification",
        "readBackAndVerified",
        "PRN",
        // dropdown
        "visits",
        "timeInterval",
        "durationInterval",
        "duration",
        // radio-group
        "approvalType",
        // quantity
        "PRNQuantity",
        // text-field
        "PRNReasons",
      ].includes(componentField);
    }
    if (!oldState.hospicePays && newState.hospicePays) {
      return ["coverageDesignation"].includes(componentField);
    }
    if (!newState.PRN && oldState.PRN === true) {
      return ["PRNReasons", "PRNQuantity", "discontinueDate"].includes(
        componentField
      );
    }
    if (newState.timeInterval !== oldState.timeInterval) {
      return ["durationInterval"].includes(componentField);
    }
    if (
      newState.PRN &&
      !newState.visits &&
      !newState.timeInterval &&
      !newState.duration &&
      !newState.durationInterval &&
      (oldState.visits ||
        oldState.timeInterval ||
        oldState.duration ||
        oldState.durationInterval)
    ) {
      return ["discontinueDate"].includes(componentField);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/add-order/order-form-state.ts